module.exports = __webpack_public_path__ + "img/back.df7d1e66.svg";